"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchasesService = void 0;
var tslib_1 = require("tslib");
var base_public_service_1 = require("../base-public-service");
var purchases_queries_1 = require("./purchases.queries");
var purchase_type_1 = require("../../mappers/purchase-type");
var date_time_1 = require("../../utils/date-time");
var globalTypes_1 = require("../generated/globalTypes");
var PurchasesService = /** @class */ (function (_super) {
    tslib_1.__extends(PurchasesService, _super);
    function PurchasesService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PurchasesService.prototype.getPurchases = function (cursor) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, purchases, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.client.request(purchases_queries_1.GET_PURCHASES, {
                            cursor: cursor,
                        })];
                    case 1:
                        response = _b.sent();
                        purchases = response.purchases.entities
                            .filter(function (_a) {
                            var status = _a.status;
                            return status === globalTypes_1.PurchaseStatus.ACTIVE ||
                                status === globalTypes_1.PurchaseStatus.CANCELED;
                        })
                            .map(function (_a) {
                            var id = _a.id, type = _a.type, expiresAt = _a.expiresAt, metaSiteId = _a.metaSiteId, createdAt = _a.createdAt, price = _a.price;
                            return ({
                                id: id,
                                type: purchase_type_1.purchaseTypeMapper.toVod(type),
                                date: createdAt,
                                dateTs: (0, date_time_1.dateToTs)(createdAt),
                                expirationTs: expiresAt ? (0, date_time_1.dateToTs)(expiresAt) : null,
                                metasiteId: metaSiteId,
                                price: price,
                            });
                        });
                        if (!response.purchases.cursor) return [3 /*break*/, 3];
                        _a = [tslib_1.__spreadArray([], purchases, true)];
                        return [4 /*yield*/, this.getPurchases(response.purchases.cursor)];
                    case 2:
                        purchases = tslib_1.__spreadArray.apply(void 0, _a.concat([(_b.sent()), true]));
                        _b.label = 3;
                    case 3: return [2 /*return*/, purchases];
                }
            });
        });
    };
    return PurchasesService;
}(base_public_service_1.BasePublicService));
exports.PurchasesService = PurchasesService;
//# sourceMappingURL=purchases.js.map